export enum SearchParameters {
  Name = 'name',
  EntityUid = 'entityUid',
  BusinessIdentifierValue = 'businessIdentifierValue',
}
